/** Bundled fallbacks in `public/assets/`; synced from deployment assets URL when online. */
export const DEPLOYMENT_ASSET_FILES = {
  logo: "ad-logo.png",
  hero: "login-five.jpg",
  login: "login-six.jpg",
  auth: "login-seven.jpg",
} as const;

export type DeploymentAssetFile =
  (typeof DEPLOYMENT_ASSET_FILES)[keyof typeof DEPLOYMENT_ASSET_FILES];

export function localDeploymentAssetPath(filename: string): string {
  return `/assets/${filename}`;
}

export function remoteDeploymentAssetUrl(
  assetsBaseUrl: string,
  filename: string,
): string {
  const base = assetsBaseUrl.replace(/\/?$/, "/");
  return `${base}${filename}`;
}

export function deploymentAssetUsesOptimizer(src: string): boolean {
  return (
    src.includes("objectstorage.apps.henga.co") ||
    src.includes("images.unsplash.com")
  );
}
